import { DataStore } from "./core";

// Store All Notifications
class Notification extends DataStore {
  constructor(name) {
    super(name);
  }
  async store(payload) {
    // Store notifications to IndexedDB
      /* TEMP Objectives:
          1. To store all notification for faster load and display before fetching new data (UX improvement)
          2. To reduce load from server by use it as only backup (Store data mainly on client side)
      */
    const timestamp = new Date().getTime();
    const topicId = `test-${timestamp}`;

    const notification = {
      ...payload,
      "id": `test://userUUID/${topicId}/issuerUUID/${timestamp}`,
      topicId,
      timestamp,
      onClient: true
    }
    await this.idb.data.put(notification);
    // id: "test", date: new Date(), sendFrom: "test", topicId: "test" });
  }
  async restore() {
    // Restore notification cache from IndexedDB
    // console.log("Restoring Notification Cache", this);

    if (this.idb) {
      // const list = await this.idb.list.toArray();
      // notifications.map(item => {
      //   this.data.set(item.id, item);
      // });

      // console.log("Check notification list", list);
      // console.log("Notifications list restored", list);
      return;
    }
  }

  // Save notification to notification pool and IndexedDB
  save() {
  // save(type, channel, id, data) {
    // console.log("Save Notification", type, channel, id, data);
    // this.data.set(`notification/`, { ...data });
    // await this.store(data);

    // if (!channel || !id) { return }

    // const id_escaped = id.includes(channel + "/") ? id.split("/")[1] : id;

    // const _id = channel + "/" + id_escaped;

    // const unify_id = type === "list" ? `${channel}/${id_escaped}` : `${type}/${channel}/${id_escaped}`;
    // let _data = null;

    // switch (type) {
    //   case "list":
    //     _data = createListData(channel, id_escaped, data);
    //     if (_data) {
    //       _data.id = _id;
    //       _data.internal_id = id_escaped;
    //       _data.unify_id = unify_id;
    //       this.list.set(unify_id, _data);
    //       this.idb.list.put(_data).then();
    //     }
    //     break;
    //   case "topic":
    //     _data = createTopicData(channel, id_escaped, data);
    //     if (_data) {
    //       _data.id = _id;
    //       _data.internal_id = id_escaped;
    //       _data.unify_id = unify_id;
    //       this.topic.set(unify_id, _data);
    //       this.idb.topic.put(_data).then();
    //     }
    //     break;
    //   default:
    //     return
    // }
  }

  // Load notification from notification pool, if not exist then load from IndexedDB and API
  async load(id) {
    let notification = this.data.get(`notification/${id}`);

    if (!notification && this.idb) {
      notification = await this.idb.data.get("test");
      // console.log("Test IndexedDB restoration", notification);
    }

    return notification || null;
  }
  update(channel, id, data) {
      const prev = this.load(channel, id);
      const newData = Object.assign(prev, data);
      this.save(channel, id, newData);
  }
  getList(channel, listname) {
      return this.load(`list/${channel}`, listname);
  }
  generateIndexes() {
      // const keys = this.data.keys();
      // console.log(keys);
  }
}

export default new Notification("notification");

// Store All Notification
// export default {
//   idbName: "notification",
//   idb: null,
//   data: new Map(),
//   list: new Map(),
//   async createIndexedDB(userUUID) {
//     await createIndexedDBHelper(userUUID, this);
//    }
//   async store(payload) {
//     // Store notifications to IndexedDB
//       /* TEMP Objectives:
//           1. To store all notification for faster load and display before fetching new data (UX improvement)
//           2. To reduce load from server by use it as only backup (Store data mainly on client side)
//       */
//     const timestamp = new Date().getTime();
//     const topicId = `test-${timestamp}`;

//     const notification = {
//       ...payload,
//       "id": `test://userUUID/${topicId}/issuerUUID/${timestamp}`,
//       topicId,
//       timestamp,
//       onClient: true
//     }
//     await this.idb.data.put(notification);
//     // id: "test", date: new Date(), sendFrom: "test", topicId: "test" });
//   },
//   async restore() {
//     // Restore notification cache from IndexedDB
//     console.log("Restoring Notification Cache", this);

//     if (this.idb) {
//       const list = await this.idb.list.toArray();
//       // notifications.map(item => {
//       //   this.data.set(item.id, item);
//       // });

//       // console.log("Check notification list", list);
//       console.log("Notifications list restored", list);
//       return;
//     }
//   },
//     async save(data) {
//         // Save notification to notification pool and IndexedDB
//         this.data.set(`notification/?`, { ...data });
//         await this.store(data);
//     },
//     async load(id) {
//         // Load notification from notification pool, if not exist then load from IndexedDB and API
//         let notification = this.data.get(`notification/${id}`);

//         if (!notification && this.idb) {
//           notification = await this.idb.data.get("test");
//           console.log("Test IndexedDB restoration", notification);
//         }

//         return notification || null;
//     },
//     update(channel, id, data) {
//         const prev = this.load(channel, id);
//         const newData = Object.assign(prev, data);
//         this.save(channel, id, newData);
//     },
//     getList(channel, listname) {
//         return this.load(`list/${channel}`, listname);
//     },
//     generateIndexes() {
//         const keys = this.data.keys();
//         console.log(keys);
//     }
// };
